import collectedOptions from '../config/collectedOptions';
import OptionWithPath from '../store/schema/OptionWithPath';
import { computed, IComputedValue } from 'mobx';

let allOptions = computed(() => {
    let allOptions: OptionWithPath[] = [];

    collectedOptions().forEach(category => {
        category.subcategories.forEach(subcategory => {
            allOptions = allOptions.concat(
                subcategory.options.map(option => ({
                    ...option,
                    categoryKey: category.key,
                    subcategoryKey: subcategory.key,
                }))
            );
        });
    });

    return allOptions;
}) as IComputedValue<OptionWithPath[]>;

export default () => allOptions.get();
